import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PaginatedPnsMacMiniResponse } from 'interfaces/pns-mac-mini'

interface MacMiniFilters {
  page?: number
  limit?: number
  ansibleId: string
  status?: string
  search?: string
  model?: string
  include?: string
}

const fetchMacMinisByAnsible = async (
  filters: MacMiniFilters
): Promise<PaginatedPnsMacMiniResponse> => {
  const params = new URLSearchParams()

  // Convert page to offset (PNS uses offset-based pagination)
  if (filters.page && filters.limit) {
    const offset = (filters.page - 1) * filters.limit
    params.append('offset', offset.toString())
  }
  if (filters.limit) params.append('limit', filters.limit.toString())
  params.append('ansibleId', filters.ansibleId)
  if (filters.status) params.append('status', filters.status)
  if (filters.search) params.append('nameSearch', filters.search)
  if (filters.model) params.append('model', filters.model)
  if (filters.include) params.append('include', filters.include)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_minis?${params.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useMacMinisByAnsible = (filters: MacMiniFilters) => {
  return useQuery(
    ['mac-minis-by-ansible', filters],
    () => fetchMacMinisByAnsible(filters),
    {
      enabled: !!filters.ansibleId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default useMacMinisByAnsible
